import {useEffect} from 'react';
import {useWidgetTitle} from '@stripe-internal/conversations-ui';
import {Title} from '../components/Title';

export function BlankScreen() {
  const {setTitle} = useWidgetTitle();

  useEffect(() => {
    setTitle(<Title />);
  }, [setTitle]);

  return null;
}
